import { api } from "../utils";

const loadIP = async ({ rootState, commit }) => {
    let resolve;
    let p = new Promise(r => resolve = r);
    console.log("loadIP");
    const res = await api.net.data.bot.load.ip();
    let { headers } = rootState.useragent;
    if (res && res.data) {
        let ip = res.data.ip || "8.8.8.8";
        headers.ip = ip;
        commit("updateUAHeaders", { headers }, { root: true });
    };
    headers.ip = headers.ip || "127.0.0.1";
    resolve(headers.ip);

    return p;
};

export default {
    loadIP,
};



// WEBPACK FOOTER //
// src/store/actions.js